import React, { useState } from 'react';
import { updateStorage, getDefaultValue } from '../../services/storageManager'
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const CustomCheckbox = ({ application, category, name, label, ...props }) => {
    const [checked, setChecked] = useState(getDefaultValue(application, category, name) || false);

    const handleCheckboxChange = (e) => {
        setChecked(e.target.checked);
        updateStorage(application, category, name, e.target.checked);
    };

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={checked}
                    onChange={handleCheckboxChange}
                    {...props}
                />
            }
            label={label}
        />
    );
};

export default CustomCheckbox;